import * as R from 'ramda';

/*
 * ACTION CREATORS & TYPES
 */

// INITIAL STATE OBJECT
const initialState = {};

// REDUCER FUNCTION
export const reducer = (state = initialState, { type /* payload */ }) => {
  switch (type) {
    default:
      return state;
  }
};

// REACT-REDUX MAPS
export const mapStateToProps = (state) => ({
  orderItems: R.pathOr([], ['cart', 'order', 'order_items'], state),
  isLoading: R.pathOr(false, ['cart', 'fetching'], state),
});
